module.exports = __webpack_public_path__ + "static/media/2025_BMS_Magasin.f557ea1f.pdf";